import type { ReactNode } from "react";
import { useQuery } from "@apollo/client/react";
import { Navigate } from "react-router-dom";
import { SESSION_CONTEXT } from "@/graphql/queries";
import { Spinner } from "@/components/ui/spinner";

type DebugAccessKey =
  | "authDebug"
  | "ddbCacheDebug"
  | "comparePerformanceDebug"
  | "compareStreamDebug"
  | "designSystem";

type SessionContextData = {
  sessionContext: {
    debugAccess: Record<DebugAccessKey | "enabled", boolean>;
  };
};

export function DebugRouteGuard({
  access,
  children,
}: {
  access: DebugAccessKey;
  children: ReactNode;
}) {
  const { data, loading } = useQuery<SessionContextData>(SESSION_CONTEXT, {
    context: { operationKind: "account" },
    fetchPolicy: "cache-and-network",
  });

  if (loading && !data) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner />
      </div>
    );
  }

  const debugAccess = data?.sessionContext.debugAccess;
  if (!debugAccess?.enabled || !debugAccess[access]) {
    return <Navigate to="/app" replace />;
  }

  return <>{children}</>;
}
